import { trpc, trpcUtils } from "@editor/utils/trpc";

import { useFetchPageFilesForWebContainer } from "@/features/web-container/useFetchPageFilesForWebContainer";
import { errorToast } from "@replo/design-system/components/alert/Toast";
import { useNavigate } from "react-router-dom";

export function useCreateFunnel() {
  const navigate = useNavigate();

  const {
    mutateAsync: createFunnelFromTemplate,
    isPending: createFunnelFromTemplateLoading,
  } = trpc.funnel.createFromTemplate.useMutation();

  const { mutateAsync: createFunnel, isPending: createFunnelLoading } =
    trpc.funnel.create.useMutation();

  const fetchPageFiles = useFetchPageFilesForWebContainer();

  const handleCreateFunnel = async ({
    projectId,
    name,
    funnelTemplateId,
  }: {
    projectId: string;
    name: string;
    funnelTemplateId?: string;
  }) => {
    try {
      let funnelId: string;
      if (funnelTemplateId) {
        const data = await createFunnelFromTemplate({
          projectId,
          funnelTemplateId,
          name,
        });
        funnelId = data.funnelId;
        await fetchPageFiles(data.pageIds.map((id) => ({ id })));
      } else {
        // NOTE (Gabe 2025-07-15): This block should not be hit - was used by
        // the CreateFunnelModal, but we don't use that anymore. @beno to clean
        // up.
        const data = await createFunnel({
          projectId: projectId ?? "",
          name,
        });
        funnelId = data.id;
      }

      void trpcUtils.funnel.list.invalidate({ projectId });

      navigate(`/shops/${projectId}/funnels/${funnelId}`);
    } catch {
      errorToast("Error creating funnel", "Please try again");
    }
  };

  return {
    handleCreateFunnel,
    isLoading: createFunnelFromTemplateLoading || createFunnelLoading,
  };
}
